import { render, staticRenderFns } from "./IntergralSta.vue?vue&type=template&id=16d1a8c7&scoped=true&"
import script from "./IntergralSta.vue?vue&type=script&lang=js&"
export * from "./IntergralSta.vue?vue&type=script&lang=js&"
import style0 from "./IntergralSta.vue?vue&type=style&index=0&id=16d1a8c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1a8c7",
  null
  
)

export default component.exports